import cx from 'classnames';
import React, { useId } from 'react';

import { Icon, IconArrowBigLeft, IconArrowBigRight } from '@flixbus/honeycomb-icons-react';
import { Tooltip } from '@flixbus/honeycomb-react';

import { useScroller } from './useScroller';

import styles from './styles.module.css';

const Scroller = ({
	children,
	scrollStep,
	step = 0.9,
	showScrollbar = false,
	showControlsAlways = false,
	styles: stylesProp = {},
	labels = {},
}) => {
	const hintIdLeft = useId();
	const hintIdRight = useId();
	const {
		ref,
		hintActive,
		showLeft,
		showRight,
		leftDisabled,
		rightDisabled,
		onClickLeft,
		onClickRight,
		onDoubleClickLeft,
		onDoubleClickRight,
	} = useScroller({ step, scrollStep, showControlsAlways });

	const { wrap, navLeft, navRight, navWrapLeft, navWrapRight, fade = true } = stylesProp;

	const {
		ariaLeft = 'Scroll left',
		ariaRight = 'Scroll right',
		hintLeft = 'Double-click to jump to the start',
		hintRight = 'Double-click to jump to the end',
	} = labels;

	const leftButton = (
		<button
			type="button"
			style={navLeft}
			aria-label={ariaLeft}
			aria-disabled={leftDisabled}
			disabled={leftDisabled}
			className={cx(styles.nav, { [styles.navDisabled]: leftDisabled })}
			onClick={leftDisabled ? undefined : onClickLeft}
			onDoubleClick={leftDisabled ? undefined : onDoubleClickLeft}
		>
			<Icon InlineIcon={IconArrowBigLeft} size={4} />
		</button>
	);

	const rightButton = (
		<button
			type="button"
			style={navRight}
			aria-label={ariaRight}
			aria-disabled={rightDisabled}
			disabled={rightDisabled}
			className={cx(styles.nav, { [styles.navDisabled]: rightDisabled })}
			onClick={rightDisabled ? undefined : onClickRight}
			onDoubleClick={rightDisabled ? undefined : onDoubleClickRight}
		>
			<Icon InlineIcon={IconArrowBigRight} size={4} />
		</button>
	);

	return (
		<div className={styles.scrollerWrap} style={wrap} data-testid="scroller-wrap">
			{fade && showLeft && <div className={styles.fadeLeft} />}
			{fade && showRight && <div className={styles.fadeRight} />}

			{showLeft && (
				<div className={cx(styles.navWrap, styles.navWrapLeft)} style={navWrapLeft}>
					{leftDisabled || !hintActive ? (
						leftButton
					) : (
						<Tooltip id={hintIdLeft} content={hintLeft} position="right" size="content-fit" active>
							{leftButton}
						</Tooltip>
					)}
				</div>
			)}

			{showRight && (
				<div className={cx(styles.navWrap, styles.navWrapRight)} style={navWrapRight}>
					{rightDisabled || !hintActive ? (
						rightButton
					) : (
						<Tooltip id={hintIdRight} content={hintRight} position="left" size="content-fit" active>
							{rightButton}
						</Tooltip>
					)}
				</div>
			)}

			<div
				ref={ref}
				className={cx(styles.scroller, { [styles.scrollerVisible]: showScrollbar })}
				data-single-scroll
				data-testid="scroller"
			>
				{children}
			</div>
		</div>
	);
};

export default Scroller;
